import "./comparisonTable.css";
import { useEffect, useRef, useState } from "react";
import MultiSelectSearchCmp from "../../MultiSelectSearchCmp";
import UpArrowIcon from "../../../../../svg/Ads_Dashboard_Developement2/UpArrownIcon/elements.svg";
import DownArrowIcon from "../../../../../svg/Ads_Dashboard_Developement2/DownArrowIcon/elements.svg";
import { Tooltip } from "@mui/joy";
import { getImageUrl, removeCommas } from "../../../../../appFunctions";
import { BASE_URL } from "../../../../../appConstants";
import axios from "axios";
import appError from "../../../../../appError";
import ImageCmp from "../../ImageCmp";
import { useNavigate, useParams } from "react-router-dom";

const UpdatedComparisonTable = ({
  setSort,
  sort,
  data,
  headerdata, // For Product Details Column Name in Header
  column, // For Metrics Column Name in Header
  parameters_hierarchy,
  sel_parameters,
  categories, // For Showing all data in Filter DropDown in Table
  setCategories, // For sorting Categories Object arrays based on Search Input field
  sel_categories, // For showing Selected data in Filter DropDown in Table
  sel_categoriesdrawer,
  setSel_Categories, // For Updating data in Filter DropDown in Table
  subTotaldata, // For Showing SubTotal Data in table
  positive_values,
  negative_values,
  metrics_row_data,
  onSelCategory,
  DropDownApplyBtn,
  DrillThroughHandler,
  cellClickHandler
}) => {
    const divRef = useRef(null);
    const [drill_through_enty_cols, setDrill_Through_entry_Cols] =  useState(["principal_category","main_category","category", "sub_category","product_name"])

    const leftRef = useRef(null);
    const rightRef = useRef(null);
    const isSyncing = useRef(false);
    const productDetailRowRef = useRef(null);

    const syncScroll = (source, target) => {
      if (!isSyncing.current) {
        isSyncing.current = true;
        target.current.scrollTop = source.current.scrollTop;
        // Small delay to release lock after scroll update
        setTimeout(() => {
          isSyncing.current = false;
        }, 0);
      }
    };
  
    const handleLeftScroll = () => {
      syncScroll(leftRef, rightRef);
    };
  
    const handleRightScroll = () => {
      syncScroll(rightRef, leftRef);
    };

    const IconTooltip = ({ name }) => {
    return (
        <div
        style={{
            backgroundColor: "#3C3C3F",
            padding: "8px",
            borderRadius: "4px",
        }}
        >
        <div
            style={{
            color: "var(--Text-Primary-White, #FFF)",
            fontFamily: "Inter",
            fontSize: "10px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "10px",
            textTransform: "upperCase",
            letterSpacing: "1.6px",
            }}
        >
            {name}
        </div>
        </div>
    );
    };

    const calculateLeftPosition = (columnType) => {
    let left = 0;

    // Iterate over keys up to the current column to sum widths
    for (const column of headerdata) {
        if (column.type === columnType) break; // Stop when reaching the current column
        left += column.width;
    }

    return left;
    };

    useEffect(() => {
        if (productDetailRowRef.current) {
          productDetailRowRef.current.scrollLeft = productDetailRowRef.current.scrollWidth;
        }
      }, [headerdata]);
      
    const hierarchy_values_arr = [];

    const Rec = (data, level, arr, product_details_cols_length) => {
        let new_arr = [...arr, {type: data?.type, name: data?.name}];

        return (
        <div style={{ display: "flex" }}>
            <div
            className="cell flex p-1 items-center justify-center gap-2 self-stretch "
            style={{
                width: headerdata.find((item) => item.type === data.type)?.width,
                position: "sticky",
                left: calculateLeftPosition(data.type),
                borderRight: product_details_cols_length - 1 === level ? "0px" : "1px solid #EAEAED",
                borderBottom:  "1px solid #EAEAED",
                // backgroundColor: "#FFF",
                height: level === product_details_cols_length - 1 ? "64px" : "100%"
            }}
            onClick={ (e) =>{ 
                e.stopPropagation();
                if(data?.type === "principal_category" || data?.type === "main_category" || data?.type === "category" || data?.type === "sub_category" || data?.type === "product_name" || data?.type === "platform_code"){
                    
                  cellClickHandler(new_arr);
                }
            }}
            >
                <div
                    className="flex justify-end items-start w-full h-full"
                    style={{
                        position: "relative",
                    }}
                >
                    <div
                    className="flex items-center justify-end gap-1 w-full"
                    style={{
                        color:
                        data?.type === "platform_code" || (data?.type=== "targeting" && data?.name?.startsWith('asin=')) || (data?.type=== "targeting" && data?.name?.startsWith('asin-expanded=')) || (data?.type === "searchterm" && data?.name?.startsWith('b0'))
                            ? "#1565C0"
                            : "var(--Text-Primary-Black, #1C1C1E)",
                        fontFamily: "Inter",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "12px",
                        position: "sticky",
                        top: "50%", // 60%
                        textWrap: "wrap",
                        textDecoration: (data?.type === "platform_code" || (data?.type=== "targeting" && data?.name?.startsWith('asin=')) || (data?.type=== "targeting" && data?.name?.startsWith('asin-expanded=')) || (data?.type === "searchterm" && data?.name?.startsWith('b0'))) && "underline",
                    }}
                    >
                    {data.type === "platform_code" && (
                        // <img
                        //   src="/Platform_Code_Icon.png"
                        //   className="h-[30px] flex-shrink-0"get
                        //   alt="Platform Code Icon"
                        // />
                    //   <img
                    //   src= {imageUrl}
                    //   className="h-[30px] flex-shrink-0"
                    //   alt="Platform Code Icon"
                    // />
                    <ImageCmp url={`https://www.amazon.in/dp/${data?.name}`}/>
                    )}
                    {/* <Tooltip
                        title={<IconTooltip name={data.name} />}
                        placement="top"
                        arrow
                        sx={{
                        bgcolor: "#3C3C3F",
                        padding: "4px 8px",
                        display: "inline-flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "8px",
                        borderRadius: "8px",
                        }}
                    > */}
                        {data?.type === "platform_code" ? (
                        <a href={`https://www.amazon.in/dp/${data?.name}`} target="_blank" rel="noopener noreferrer" ref={divRef} className="flex w-full text-wrap break-words break-all justify-start" onClick={(e) => e.stopPropagation()}>
                        {/* {data.name.length > 11
                            ? data.type !== "platform_code"
                            ? `${data.name.substring(0, 11)}...`
                            : `${data.name}`
                            :`${data.name}`} */}
                            {data?.name}
                        </a>
                        ) : data?.type === "targeting" && data?.name?.startsWith('asin=') ||  data?.type === "targeting" && data?.name?.startsWith('asin-expanded=') ? (
                            <a href={`https://www.amazon.in/dp/${data?.name?.split('=')[1]?.replace(/"/g, '')}`} target="_blank" rel="noopener noreferrer" ref={divRef} className="flex w-full text-wrap break-words break-all justify-start">
                            {/* {data.name.length > 11
                            ? data.type !== "platform_code"
                                ? `${data.name.substring(0, 11)}...`
                                : `${data.name}`
                            :`${data.name}`} */}
                            {data?.name}
                        </a>
                        ) : data?.type === "searchterm" && data?.name?.startsWith('b0')  ? (
                        <a href={`https://www.amazon.in/dp/${String(data?.name)?.toLocaleUpperCase()}`} target="_blank" rel="noopener noreferrer" ref={divRef} className="flex text-wrap break-words break-all w-full justify-start">
                            {/* {data.name.length > 11
                            ? data.type !== "platform_code"
                                ? `${data.name}...`
                                : `${data.name}`
                            :`${data.name}`} */}
                            {data?.name}
                        </a>
                        ) : ( 
                        <div ref={divRef} className="flex w-full text-wrap break-words break-all justify-start"
                        >
                        {/* {data.name.length > 11
                            ? data.type !== "platform_code"
                            ? `${data.name.substring(0, 11)}...`
                            : `${data.name}`
                            :`${data.name}`} */}
                            {data?.name}
                        </div>)
                        }
                    {/* </Tooltip> */}

                    {/* // Non Functional Button */}
                     {/* <div
                        className="flex p-1 h-fit items-center gap-1 rounded-[4px]"
                        style={{
                        background: "#F2F2F5",
                        }}
                    >
                        <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        >
                        <path
                            d="M5.75 7.4V4.6C5.75 4.48333 5.7 4.40417 5.6 4.3625C5.5 4.32083 5.40833 4.34167 5.325 4.425L4.1 5.65C4 5.75 3.95 5.86667 3.95 6C3.95 6.13333 4 6.25 4.1 6.35L5.325 7.575C5.40833 7.65833 5.5 7.67917 5.6 7.6375C5.7 7.59583 5.75 7.51667 5.75 7.4ZM2.5 10.5C2.225 10.5 1.98958 10.4021 1.79375 10.2063C1.59792 10.0104 1.5 9.775 1.5 9.5V2.5C1.5 2.225 1.59792 1.98958 1.79375 1.79375C1.98958 1.59792 2.225 1.5 2.5 1.5H9.5C9.775 1.5 10.0104 1.59792 10.2063 1.79375C10.4021 1.98958 10.5 2.225 10.5 2.5V9.5C10.5 9.775 10.4021 10.0104 10.2063 10.2063C10.0104 10.4021 9.775 10.5 9.5 10.5H2.5ZM8 9.5H9.5V2.5H8V9.5ZM7 9.5V2.5H2.5V9.5H7Z"
                            fill="#97979A"
                        />
                        </svg>
                    </div>   */}
                    {drill_through_enty_cols?.includes(data?.type) && (<div
                        className="flex p-1 h-fit items-center gap-1 rounded-[4px]"
                        style={{
                        background: "#F2F2F5",
                        cursor: "pointer"
                        }}
                        onClick={(e) => {
                            e.stopPropagation(); // Prevent the click from bubbling up
                            DrillThroughHandler(new_arr);
                          }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M2 9C1.85833 9 1.73958 8.95208 1.64375 8.85625C1.54792 8.76042 1.5 8.64167 1.5 8.5C1.5 8.35833 1.54792 8.23958 1.64375 8.14375C1.73958 8.04792 1.85833 8 2 8H7.5C7.64167 8 7.76042 8.04792 7.85625 8.14375C7.95208 8.23958 8 8.35833 8 8.5C8 8.64167 7.95208 8.76042 7.85625 8.85625C7.76042 8.95208 7.64167 9 7.5 9H2ZM9.45 8.15L7.65 6.35C7.55 6.25 7.5 6.13333 7.5 6C7.5 5.86667 7.55 5.75 7.65 5.65L9.45 3.85C9.54167 3.75833 9.65833 3.7125 9.8 3.7125C9.94167 3.7125 10.0583 3.75833 10.15 3.85C10.2417 3.94167 10.2875 4.05833 10.2875 4.2C10.2875 4.34167 10.2417 4.45833 10.15 4.55L8.7 6L10.15 7.45C10.2417 7.54167 10.2875 7.65833 10.2875 7.8C10.2875 7.94167 10.2417 8.05833 10.15 8.15C10.0583 8.24167 9.94167 8.2875 9.8 8.2875C9.65833 8.2875 9.54167 8.24167 9.45 8.15ZM2 6.5C1.85833 6.5 1.73958 6.45208 1.64375 6.35625C1.54792 6.26042 1.5 6.14167 1.5 6C1.5 5.85833 1.54792 5.73958 1.64375 5.64375C1.73958 5.54792 1.85833 5.5 2 5.5H6C6.14167 5.5 6.26042 5.54792 6.35625 5.64375C6.45208 5.73958 6.5 5.85833 6.5 6C6.5 6.14167 6.45208 6.26042 6.35625 6.35625C6.26042 6.45208 6.14167 6.5 6 6.5H2ZM2 4C1.85833 4 1.73958 3.95208 1.64375 3.85625C1.54792 3.76042 1.5 3.64167 1.5 3.5C1.5 3.35833 1.54792 3.23958 1.64375 3.14375C1.73958 3.04792 1.85833 3 2 3H7.5C7.64167 3 7.76042 3.04792 7.85625 3.14375C7.95208 3.23958 8 3.35833 8 3.5C8 3.64167 7.95208 3.76042 7.85625 3.85625C7.76042 3.95208 7.64167 4 7.5 4H2Z" fill="#97979A"/>
                        </svg>
                    </div>)}
                    </div>
                </div>
            </div>

            {data?.children?.length > 0 && (
            <div style={{ display: "flex", flexDirection: "column" }}>
                {data.children.map((data) => {
                return Rec(data, level + 1, new_arr, product_details_cols_length);
                })}
            </div>
            )}
        </div>
        );
    };

    const getProduct_Details_Section_width = () => {
        let new_width = 0;

        headerdata?.map((item) => {
            new_width += item?.width
        })
        return new_width;
    }

    const [rsmatricearr, setRsMatricearr] = useState(["spend", "sales", "gross_sales", "organic_sales"]);
    return (
    <div className="" style={{
        width: "calc(100vw - 71px - 46px)",
        // height: "calc(100vh - 379px)",
        // height: "576px"
        height: "calc(100vh - 280px)",
      }}>
        <div className="flex"
        style={{
            width: "calc(100vw - 71px - 46px)",
            // height: "calc(100vh - 379px)",
            // height: "576px"
            height: "calc(100vh - 280px)",
        }}
        >

            {/* Left Side */}
            <div className="bg-[#fff] flex flex-col" 
                ref={productDetailRowRef}
                style={{
                    borderLeft: "1px solid #EAEAED",
                    borderRight: "1px solid #EAEAED",
                    overflowY:"auto",
                    position: "relative",
                    boxShadow: "1px 0px 10px 4px rgba(130,130,130,0.05)",
                    // maxHeight: "calc(100vh - 379px)",
                    maxWidth: 350,
            }}>
                <div className="h-[152px] relative" style={{
                    // maxWidth:600,
                    width: getProduct_Details_Section_width()
                }}>
                    <div
                    className="flex h-[44px] px-6 py-2 justify-center items-center gap-2 self-stretch"
                    style={{
                    textAlign: "center",
                    background: "#F3F3F7",
                    borderBottom: "1px solid #EAEAED",
                    position:"sticky",
                    top:0,
                    left:0,
                    maxWidth: 350,
                    }}
                    >
                        <div
                        style={{
                            color: "var(--Text-Primary-Black, #1C1C1E)",
                            textAlign: "center",
                            fontFamily: "Inter",
                            fontSize: "10px",
                            fontStyle: "normal",
                            fontWeight: 700,
                            lineHeight: "14px",
                        }}
                        >
                        Product Details
                        </div>
                    </div>
                    <div style={{ display: "flex", width: "100%"}}>
                        {headerdata &&
                        headerdata.length > 0 &&
                        headerdata?.map((d, index) => {

                            return (<div
                            className="cell flex h-[44px] px-2 py-2 justify-between items-center gap-2"
                            style={{
                                width: d?.width,
                                backgroundColor: "#F3F3F7",
                                borderRight: headerdata?.length - 1 === index ? "0px" : "1px solid #EAEAED",
                                position: "relative",
                            }}
                            key={headerdata?.title_name}
                            >
                            <div
                                style={{
                                color: "var(--Text-Primary-Black, #1C1C1E)",
                                textAlign: "start",
                                fontFamily: "Inter",
                                fontSize: "10px",
                                fontStyle: "normal",
                                fontWeight: 700,
                                lineHeight: "14px",
                                }}
                            >
                                {d?.title_name}
                            </div>
                            <MultiSelectSearchCmp
                                searchcat={d?.type}
                                childrenarr={categories[d?.type]}
                                setCategories={setCategories}
                                selectedarr={sel_categoriesdrawer[d?.type]}
                                sel_categories={sel_categories}
                                setSel_Categories={setSel_Categories}
                                onSelCategory={onSelCategory}
                                DropDownApplyBtn={DropDownApplyBtn}
                            />
                            </div>
                        )})}
                    </div>
                    <div
                        className="flex h-[64px] px-6 py-2 items-center gap-2 self-stretch "
                        style={{
                        backgroundColor: "#FAFAFA",
                        //   borderBottom: "1px solid #EAEAED",
                        position:"sticky",
                        top:0,
                        left:0,
                        maxWidth: 350,
                        borderBottom: "1px solid #EAEAED",
                        }}
                    >
                        <div
                        style={{
                            color: "var(--Text-Primary-Black, #1C1C1E)",
                            fontFamily: "Inter",
                            fontSize: "10px",
                            fontStyle: "normal",
                            fontWeight: "700",
                            lineHeight: "14px",
                        }}
                        >
                        Subtotal
                        </div>
                    </div>
                </div>
                
                <div className="flex flex-col"
                ref={leftRef}
                onScroll={handleLeftScroll}
                style={{
                    width: getProduct_Details_Section_width(),
                    // maxHeight: "calc(100vh - 379px - 152px)",
                    // maxHeight: "3200px",
                    // height: "512px",
                    maxHeight: "calc(100vh - 280px - 152px)",
                    overflowX:"auto",
                    scrollbarWidth:"none",
                }}>
                    {data.map((data) => {
                        return Rec(data, 0, hierarchy_values_arr, headerdata?.length);
                    })}
                </div>
            </div>


            {/* Right Side */}
            <div 
            className="flex flex-col "
            style={{
                maxWidth:`calc(100vw - 71px - 30px - ${headerdata?.length < 3 ? getProduct_Details_Section_width() : 350}px)`,
                overflow:"auto",
                // scrollbarWidth:"none",
                position:"relative",
                // maxHeight: "calc(100vh - 379px)",
                borderRight: "1px solid #EAEAED",
            }}>
                <div className="h-[152px]" style={{
                    width: `calc(${column?.length} * 80px)`,
                    position:"sticky",
                    top:0,
                    left: 0
                }}>
                    <div
                    className="cell flex h-[44px] px-2 py-2 justify-center items-center gap-2 self-stretch"
                    style={{
                    textAlign: "center",
                    background: "#F3F3F7",
                    //   borderBottom: "1px solid #EAEAED",
                    position:"sticky",
                    top:0,
                    left:0,
                    borderRight: 0,
                    maxWidth: `calc(100vw - 71px - 30px - ${headerdata?.length < 3 ? getProduct_Details_Section_width() : 350}px)`,
                    }}
                >
                    <div
                    style={{
                        color: "var(--Text-Primary-Black, #1C1C1E)",
                        textAlign: "center",
                        fontFamily: "Inter",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: 700,
                        lineHeight: "14px",
                    }}
                    >
                    Metrics
                    </div>
                </div>
                <div style={{ display: "flex", width: `calc(${column?.length} * 80px)`}}>
                    {column?.map((el, index) => {
                    return (
                        <div
                        className="cell flex w-[80px] h-[44px] px-1 py-2 justify-end items-center gap-1 cursor-pointer"
                        style={{
                            backgroundColor: "#F3F3F7",
                            borderRight: "0px",
                        }}
                        onClick={() =>
                            setSort((prev) => {
                            if (prev.metric !== el.field) {
                                return {
                                ...prev,
                                metric: el.field,
                                direction: "ASC",
                                };
                            } else if (prev.metric === el.field) {
                                if (prev.direction === "ASC") {
                                return {
                                    ...prev,
                                    direction: "DESC",
                                };
                                } else if (prev.direction === "DESC") {
                                return {
                                    ...prev,
                                    direction: "",
                                };
                                } else if (prev.direction === "") {
                                return {
                                    ...prev,
                                    direction: "ASC",
                                };
                                }
                            }
                            })
                        }
                        >
                        <div
                            style={{
                            color: "var(--Text-Primary-Black, #1C1C1E)",
                            textAlign: "end",
                            fontFamily: "Inter",
                            fontSize: "10px",
                            fontStyle: "normal",
                            fontWeight: 700,
                            lineHeight: "14px",
                            }}
                        >
                            {el.headerName}
                        </div>
                        {sort.metric === el.field && sort.direction === "ASC" && (
                            <img
                            src={UpArrowIcon}
                            alt="Icon"
                            style={{ cursor: "pointer" }}
                            // onClick={() => setDateToggle(true)}
                            />
                        )}
                        {sort.metric === el.field && sort.direction === "DESC" && (
                            <img
                            src={DownArrowIcon}
                            alt="Icon"
                            style={{ cursor: "pointer" }}
                            // onClick={() => setDateToggle(true)}
                            />
                        )}
                        </div>
                    );
                    })}
                </div>
                {subTotaldata.length > 0 && (
                    <div style={{ display: "flex", flexDirection: "column",  }}>
                    {subTotaldata.map((data) => {
                        return (
                        <div style={{ display: "flex" }}>
                            {column?.map(({ headerName, field }, index) => {
                            return (
                                <div
                                style={{
                                    display: "flex",
                                    width: "80px",
                                    height: "64px",
                                    padding: "4px",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "2px",
                                    backgroundColor: "#FAFAFA",
                                    borderBottom: "1px solid #EAEAED",
                                }}
                                >
                                <div className="flex flex-col gap-[2px] w-full">
                                    {parameters_hierarchy?.map((parameter) => {
                                    if(sel_parameters.includes(parameter)){

                                    let color_val = "#1C1C1E"; // Default color for "current"

                                    if (parameter === "previous") {
                                        color_val = "#97979A";
                                    } else if (
                                        parameter === "difference" ||
                                        parameter === "difference_percentage"
                                    ) {
                                        if (positive_values.includes(field)) {
                                        if (
                                            Number(removeCommas(data[field]?.["current"])) >
                                            Number(removeCommas(data[field]?.["previous"]))
                                        ) {
                                            color_val = "#186846";
                                        } else if (
                                            Number(removeCommas(data[field]?.["current"])) <
                                            Number(removeCommas(data[field]?.["previous"]))
                                        ) {
                                            color_val = "#D10C00";
                                        } else if (
                                            Number(removeCommas(data[field]?.["current"])) ===
                                            Number(removeCommas(data[field]?.["previous"]))
                                        ) {
                                            color_val = "#8B6509";
                                        }
                                        } else if (negative_values.includes(field)) {
                                        if (
                                            Number(removeCommas(data[field]?.["current"])) >
                                            Number(removeCommas(data[field]?.["previous"]))
                                        ) {
                                            color_val = "#D10C00";
                                        } else if (
                                            Number(removeCommas(data[field]?.["current"])) <
                                            Number(removeCommas(data[field]?.["previous"]))
                                        ) {
                                            color_val = "#186846";
                                        } else if (
                                            Number(removeCommas(data[field]?.["current"])) ===
                                            Number(removeCommas(data[field]?.["previous"]))
                                        ) {
                                            color_val = "#8B6509";
                                        }
                                        }
                                    }

                                    return (
                                        <div
                                        style={{
                                            color: color_val,
                                            textAlign: "end",
                                            fontFamily: "Inter",
                                            fontSize: sel_parameters?.length <= 2 ? 
                                                parameter === "current" ? "12px" : "10px" : 
                                                parameter === "current" ? "10px" : "8px",
                                            fontStyle: "normal",
                                            fontWeight:
                                                parameter === "current"
                                                ? 700
                                                : parameter === "previous"
                                                ? "400"
                                                : "500",
                                            lineHeight: sel_parameters?.length <= 2 ? 
                                                parameter === "current" ? "16px" : "14px" : 
                                                parameter === "current" ? "14px" : "12px",
                                        }}
                                        >
                                        {parameter === "difference_percentage" ? `${data[field]?.[parameter]}%` :  rsmatricearr?.includes(field) ? `₹ ${data[field]?.[parameter]}` : `${data[field]?.[parameter]}`}
                                        </div>
                                    );
                                    }
                                    })}
                                </div>
                                </div>
                            );
                            })}
                        </div>
                        );
                    })}
                    </div>
                )}
                </div>

                <div className="flex flex-col" 
                ref={rightRef}
                onScroll={handleRightScroll}
                style={{
                    width: column?.length * 80,
                    // height: "calc(100vh - 379px - 165x)",
                    // minHeight: "calc(100vh - 72px - 470px)",
                    // height: "512px",
                    maxHeight: "calc(100vh - 280px - 152px)",
                    overflowX:"auto",
                    backgroundColor:"white",
                    scrollbarWidth:"none" // for display none of scrollbar from top to bottom
                }}>
                    {   metrics_row_data?.length > 0 && (
                            <div style={{ display: "flex", flexDirection: "column" }}>
                            {metrics_row_data?.map((data, ) => {
                                return (
                                <div style={{ display: "flex" }}>
                                    {column?.map(({ headerName, field }, index) => {
                                    return (
                                        <div
                                        style={{
                                            display: "flex",
                                            width: "80px",
                                            height: "64px",
                                            padding: "4px",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: "2px",
                                            backgroundColor: "#FFF",
                                            borderBottom: "1px solid #EAEAED",
                                        }}
                                        >
                                        <div className="flex flex-col w-full">
                                            {parameters_hierarchy?.map((parameter) => {
                                            if(sel_parameters.includes(parameter)){
                                            let color_val = "#1C1C1E"; // Default color for "current"
                
                                            if (parameter === "previous") {
                                                color_val = "#97979A";
                                            } else if (
                                                parameter === "difference" ||
                                                parameter === "difference_percentage"
                                            ) {
                                                if (positive_values.includes(field)) {
                                                    if (
                                                        Number(removeCommas(data[field]?.["current"])) >
                                                        Number(removeCommas(data[field]?.["previous"]))
                                                    ) {
                                                        color_val = "#186846";
                                                    } else if (
                                                        Number(removeCommas(data[field]?.["current"])) <
                                                        Number(removeCommas(data[field]?.["previous"]))
                                                    ) {
                                                        color_val = "#D10C00";
                                                    } else if (
                                                        Number(removeCommas(data[field]?.["current"])) ===
                                                        Number(removeCommas(data[field]?.["previous"]))
                                                    ) {
                                                        color_val = "#8B6509";
                                                    }
                                                } else if (negative_values.includes(field)) {
                                                    if (
                                                        Number(removeCommas(data[field]?.["current"])) >
                                                        Number(removeCommas(data[field]?.["previous"]))
                                                    ) {
                                                        color_val = "#D10C00";
                                                    } else if (
                                                        Number(removeCommas(data[field]?.["current"])) <
                                                        Number(removeCommas(data[field]?.["previous"]))
                                                    ) {
                                                        color_val = "#186846";
                                                    } else if (
                                                        Number(removeCommas(data[field]?.["current"])) ===
                                                        Number(removeCommas(data[field]?.["previous"]))
                                                    ) {
                                                        color_val = "#8B6509";
                                                    }
                                                }
                                            }
                
                                            return (
                                                <div
                                                key={parameter}
                                                style={{
                                                    color: color_val,
                                                    textAlign: "right",
                                                    fontFamily: "Inter",
                                                    fontSize: sel_parameters?.length <= 2 ? 
                                                        parameter === "current" ? "12px" : "10px" :
                                                        parameter === "current" ? "10px" : "8px",
                                                    fontStyle: "normal",
                                                    fontWeight:
                                                    parameter === "current" ||
                                                    parameter === "previous"
                                                        ? "400"
                                                        : "500",
                                                    lineHeight: sel_parameters?.length <= 2 ? 
                                                        parameter === "current" ? "16px" : "14px" :
                                                        parameter === "current" ? "14px" : "12px",
                                                }}
                                                >
                                                {parameter === "difference_percentage" ? `${data[field]?.[parameter]}%` : rsmatricearr?.includes(field) ? `₹ ${data[field]?.[parameter]}` : `${data[field]?.[parameter]}` }
                
                                                {/* {data[field]?.[parameter] &&
                                                    formatNumber(
                                                    Number(data[field]?.[parameter])
                                                    )}
                                                {data[field]?.[parameter] &&
                                                    parameter === "difference_percentage" &&
                                                    " %"} */}
                                                </div>
                                            );
                                            }
                                            })}
                                        </div>
                                        </div>
                                    );
                                    })}
                                </div>
                                );
                            })}
                            </div>
                        )
                    }
                </div>
            </div>
        </div>

        <div className="h-[60px] w-full "></div>
    </div>
  );
};

export default UpdatedComparisonTable;

